import React from 'react'
import AmbulatoryProceduresLayout from 'presentation/doctor/layouts/AmbulatoryProcedures'

function AmbulatoryProcedures() {
  return <AmbulatoryProceduresLayout />
}

export default AmbulatoryProcedures
